
import { getSectionStyle, shuffleArray } from "@/utils";

import ProductRowSlider from "../ProductRowSlider";
import ProductList from "../category/ProductList";
import classes from "./FeaturedProducts.module.css";



async function getProductsByIds(ids: number[]): Promise<ProductItem[]> {
  try {
    const res = await fetch(`${process.env.NEXT_PUBLIC_BASE_API}product/storefront/get-by-ids`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ids }),
      next: { revalidate: 600 }, // 10 minutes
    });
    if (!res.ok) return [];
    const json: ProductListResponse = await res.json();
    return json?.data ?? [];
  } catch {
    return [];
  }
}

async function getProductsByLogic(logical: LogicBuilder): Promise<ProductItem[]> {
  try {
    const res = await fetch(`${process.env.NEXT_PUBLIC_BASE_API}product/storefront/get-by-logic`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(logical),
      next: { revalidate: 600 }, // 10 minutes
    });
    if (!res.ok) return [];

    let json: ProductItem[] = await res.json();
    if (
      !logical?.isFeatured &&
      (logical?.categoryOrder === "random" ||
        logical?.brandOrder === "random")
    ) {
      shuffleArray(json);
    }
    return json ?? [];
  } catch {
    return [];
  }
}

const FeaturedProducts = async ({ widget }: { widget?: any }) => {
  let products: ProductItem[] = [];

  if (widget?.data?.setting?.custom?.length) {
    products = await getProductsByIds(
      widget.data.setting.custom.map((p: any) => p.id),
    );
  } else if (widget?.data?.setting?.logical) {
    products = await getProductsByLogic(widget?.data?.setting?.logical);
  }

  if (!products.length) return null;

  const settings = widget?.data?.settings || {};

  return (
    <section className={classes.FeaturedProducts} style={getSectionStyle(settings)}>
      <div className="container">
        {widget?.data?.isSlider ? (
          <ProductRowSlider
            key={widget?.id + "featuredProducts"}
            uid={widget?.id + "featuredProducts"}
            products={products}
            settings={widget?.data?.settings}
            loading={false}
          />
        ) : (
          <ProductList
            className="pb-3 md:pb-6"
            key={widget?.id + "featuredProducts"}
            products={products}
            loading={false}
          />
        )}
      </div>
    </section>
  );
};

export default FeaturedProducts;
